import { useTranslation } from "react-i18next";
import KiloNewtonMillimetre from "../../../../../../components/Math/Units/Metric/KiloNewtonMillimetre";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

//Bemessungswert der Momenten-Tragfähigkeit
const M_Rd_Formula = `\\displaystyle M_{\\tiny _{Rd}} = W_{s} \\cdot \\frac{f_{\\tiny _{yk}}}{\\gamma_{\\tiny _{M}}}`;
function BemessungswertDerMomentenTragfaehigkeit({ elastischeMomententragfaehigkeit }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={
        <p>
          {t(
            "inner.buckling.ofner.loadbearingCapacitiesMicropile.designValueMomentanForceBearingCapacity"
          )}
        </p>
      }
      indicesValue={
        <span>
          M<sub>Rd</sub>
        </span>
      }
      formulaValue={<ToolTip id={"M_Rd_Formula"} type={IconType.FORMULA} formula={M_Rd_Formula} />}
      inputValue={
        <span className="input">
          <NumberFormatText value={elastischeMomententragfaehigkeit} decimalScale={0} />
        </span>
      }
      unitValue={<KiloNewtonMillimetre />}
    />
  );
}

export default BemessungswertDerMomentenTragfaehigkeit;
